import React, { useEffect, useState } from 'react';
import {
  useDisclosure
} from '@chakra-ui/react';
import BusinessDetailsEdit from '../edit-license/BusinessDetailsEdit';
import {
  getBusinessDetailsEdited, getTransferFeesEdited, getOptinOptoutEdited, getContactDetailsEdit, getCustomAddressEdit, getIsBlacklisted, getDefaultShippingAddressEdited, getIsSendingDealerProfileEditEmail,
  getIsLicenseRemoved, getEzCheckHistory, getDealerOptOutValue, getIsDealerProfileEditEmailSended, getIsEzCheckHistoryInCompleted, getIsEzCheckHistoryInprogress, getIsDealerOptOut, getIsLicenseHistoryCompleted, getIsLicenseHistoryInProgress, getLicenseHistoryList, getIsShootingRangeRevert
} from '@/explore/ducks/selectors';
import EditTransferFee from '../edit-transfer-fee';
import { isUndefined } from 'lodash';
import { LicenseDetailsProps } from '@/explore/types';
import { useDispatch } from 'react-redux';
import {
  callToGetEZCheckValidatorHistory, callToGetLicenseHistory, callToRemoveLicense, callToSendProfileEditEmail,
  callToShootingChange,
  resetBusinessDetails, resetTransferFeeEdited, setContactDetailsEdit, setCustomAddressEdit, setDealerOptOutValue, setEZCheckHistory, setIsBlackListed, setIsDealerOptOut, setIsDealerProfileEditEmailSended, setIsEzCheckHistoryCompleted, setIsEzCheckHistoryInprogress, setIsLicenseHistoryCompleted, setIsLicenseHistoryInProgress, setIsLicenseRemoved, setIsShootingRevert, setLicenseHistory, setOptinOptoutEdited
} from '@/explore/ducks/slice';
import { ezCheck, formatLicenseKey, getPrimary } from '../utils.mjs';
import { downloadMasterProofPdfFile, getMasterProofStatus } from '@/api/apis';
import { ToasterNotification } from '@/toaster/toasterNotification';
import ConfirmationModal from '@/common/ConfirmationModal';
import { ShowTransferModel } from '@/queue/elements/QueueGrid';
import { getCreateTransferData, getTotalTransfersCount } from '@/queue/ducks/selectors';
import { FFLDealerDetails } from '@masterffl/dealer-detail-component';
import TransferModal from '@/queue/elements/TransferForm';
import { useSearchParams } from 'react-router-dom';
import { BLACKLIST_ERROR, optOutExploreMessage } from '@/utils/constants';
import { ErrorToasterNotification, OutlineToasterNotification } from '@/toaster/successNotification';
import { logAnalyticsEvent } from '@/utils/analyticsLogger';
import { analyticsEvents } from '@/utils/analyticsEvents';
function LicenseDetails({ data, isSuperAdmin }: LicenseDetailsProps) {
  const dispatch = useDispatch();
  const [processingDownload, setProcessingDownload] = useState(false);
  const isSendingDealerProfileEditEmail = getIsSendingDealerProfileEditEmail();
  const [isShootingRangeChecked, setIsShootingRangeChecked] = useState(false);

  useEffect(() => {
    return () => {
      dispatch(setDealerOptOutValue(''));
      dispatch(setIsDealerOptOut(false));
      dispatch(resetBusinessDetails())
      dispatch(resetTransferFeeEdited())
      dispatch(setOptinOptoutEdited(""))
    }
  }, [])

  useEffect(() => {
    dispatch(setIsBlackListed(data?.isBlacklisted))
    if(data && data.isRange){
      setIsShootingRangeChecked(data.isRange);
    }
    if (data && data.optOutOptions) {
      dispatch(setDealerOptOutValue(data.optOutOptions));
      dispatch(setIsDealerOptOut(data.optOutOptions === 'all' || data.optOutOptions === 'store'));
    }
  }, [data])


  useEffect(() => {
    dispatch(resetTransferFeeEdited());
    dispatch(resetBusinessDetails());
    dispatch(setContactDetailsEdit(null));
    dispatch(setCustomAddressEdit(null));
  }, [])
  const transferFeeEdtited = getTransferFeesEdited();
  const optinOptoutOption = getOptinOptoutEdited();
  const contactDetailsEdit = getContactDetailsEdit();
  const customAddressEdit = getCustomAddressEdit();
  const isBlacklisted = getIsBlacklisted();
  const defaultShippingAddressEdited = getDefaultShippingAddressEdited();
  const createTransferDetails = getCreateTransferData();

  const {
    isOpen: isBusinessDetailsEditDropdownActive,
    onClose: onCloseBusinessDetailsEditDropdown,
    onOpen: onOpenBusinessDetailsEditDropdown
  } = useDisclosure();

  const {
    isOpen: isTrasnferEditModalActive,
    onClose: onCloseTrasnferEditModalActive,
    onOpen: onOpenTrasnferEditModalActive
  } = useDisclosure();
  const {
    isOpen: isEZDropDOwnActive,
    onClose: onCloseEZDropdown,
    onOpen: onOpenEZDropdown
  } = useDisclosure();
  const {
    isOpen: isProfileModalOpen,
    onClose: onCloseProfileModal,
    onOpen: onOpenProfileModal
  } = useDisclosure();
  const {
    isOpen: isTransferModalOpen,
    onClose: onCloseTransferModal,
    onOpen: onOpenTransferModal
  } = useDisclosure();
  const {
    isOpen: isTransferOpen,
    onOpen: onTransferOpen,
    onClose: onTransferClose
  } = useDisclosure();
  const onClickEditBusinessDetails = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.stopPropagation();
    onOpenBusinessDetailsEditDropdown();
  };

  const onClickEditTransferDetails = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.stopPropagation();
    onOpenTrasnferEditModalActive();
  };

  const optinOptoutValue = optinOptoutOption || data?.optOutOptions || "";
  const transferFees = {
    pistol_fee: isUndefined(transferFeeEdtited.pistol_fee) ? data?.transferFees?.pistolFee : transferFeeEdtited.pistol_fee,
    pistol_enabled: isUndefined(transferFeeEdtited.pistol_enabled) ? data?.transferFeesStatus?.pistol_enabled : transferFeeEdtited.pistol_enabled,
    rifle_fee: isUndefined(transferFeeEdtited.rifle_fee) ? data?.transferFees?.rifleFee : transferFeeEdtited.rifle_fee,
    rifle_enabled: isUndefined(transferFeeEdtited.rifle_enabled) ? data?.transferFeesStatus?.rifle_enabled : transferFeeEdtited.rifle_enabled,
    sbr_enabled: isUndefined(transferFeeEdtited.sbr_enabled) ? data?.transferFeesStatus?.sbr_enabled : transferFeeEdtited.sbr_enabled,
    sbr_fee: isUndefined(transferFeeEdtited.sbr_fee) ? data?.transferFees?.sbrFee : transferFeeEdtited.sbr_fee,
    nics_fee: isUndefined(transferFeeEdtited.nics_fee) ? data?.transferFees?.nicsFee : transferFeeEdtited.nics_fee,
    suppressor_fee: isUndefined(transferFeeEdtited.suppressor_fee) ? data?.transferFees?.nfaFee : transferFeeEdtited.suppressor_fee,
    discount_multiple_firearms: isUndefined(transferFeeEdtited.discount_multiple_firearms) ? data?.transferFees?.discountMultipleFirearms : transferFeeEdtited.discount_multiple_firearms,
  }

  const businessDetailsEdited = getBusinessDetailsEdited();
  const contactNames = businessDetailsEdited.contacts ? businessDetailsEdited.contacts : (data?.contactNames || []);
  const websites = businessDetailsEdited.websites ? businessDetailsEdited.websites : (data?.websiteUrls || []);
  const phones = businessDetailsEdited.phones ? businessDetailsEdited.phones : (data?.contact?.formattedPhoneNumbers || []);
  const emails = businessDetailsEdited.emails ? businessDetailsEdited.emails : (data?.contact.formattedEmails || []);
  const contactDetailsList = contactDetailsEdit || data?.contactDetails;
  const customeAddressList = customAddressEdit || data?.customAddress;
  const defaultShippingAddress = defaultShippingAddressEdited || data.defaultShippingAddress;
  const isDealerOptOut = getIsDealerOptOut();
  const dealerOptOutValue = getDealerOptOutValue();
  const isShootingRangeRevert = getIsShootingRangeRevert();

  useEffect(() => {
    const elements = document.getElementsByClassName('chakra-collapse') as any;
    // Check if the element is found
    if (elements && elements.length) {
      for (var i = 0; i < elements.length; i++) {
        elements[i].style.display = 'block';
      }
    }
  }, [data])

  useEffect(() => {
    if (createTransferDetails) {
      onOpenTransferModal();
    }
  }, [createTransferDetails])

  useEffect(() => {
    if (isShootingRangeRevert) {
      setIsShootingRangeChecked(data.isRange);
      dispatch(setIsShootingRevert(false));
    }
  }, [isShootingRangeRevert])


  function handleEzCheck() {
    ezCheck(dispatch, { license_key: data?.license_key });
  }

  function clearHistoryData() {
    dispatch(setEZCheckHistory([]));
    dispatch(setLicenseHistory([]));
    dispatch(setIsEzCheckHistoryInprogress(false));
    dispatch(setIsEzCheckHistoryCompleted(false));
  }

  const handleEzCheckHistory = () => {
    clearHistoryData();
    dispatch(callToGetEZCheckValidatorHistory({ license_key: data?.license_key }));
  };

  const onOpenEZDropdownHanlder = () => {
    handleEzCheckHistory();
    onOpenEZDropdown();
  };
  function downloadPdfFile() {
    setProcessingDownload(true);
    const licenseKey = `${data?.id.substring(0, 1)}${data?.id.substring(
      2,
      4
    )}${data?.id.substring(data?.id.length - 5)}`;
    downloadMasterProofPdfFile(licenseKey)
      .then((res: any) => {
        if (res?.data && res?.data?.Error) {
          ToasterNotification('failed', res.Error);
          return;
        }
        const { request_id: requestId } = res?.data;
        const masterProofStatusInterval = setInterval(async () => {
          const response = await getMasterProofStatus(requestId);
          if (response.data.status === "SUCCESS") {
            clearInterval(masterProofStatusInterval);
            const url = response.data.document_link;
            const downloadLink = document.createElement('a');
            downloadLink.href = url;
            downloadLink.download = `Dealer_Master_Proof_${licenseKey}.pdf`; // Set the desired filename
            downloadLink.click();
            URL.revokeObjectURL(url);
            setProcessingDownload(false);
          }
        }, 2000);
      })
      .catch((e: any) => {
        if (e && e.response.data && e.response.data.Error)
          ToasterNotification('failed', e.response.data.Error);
        console.log('Error in downloading: ', String(e));
        setProcessingDownload(false);
      })
  }
  const LicenseRemoved = (licenseProof: boolean) => {
    dispatch(setIsLicenseRemoved(licenseProof))
  }
  const DealerProfileEditEmailSended = () => {
    dispatch(setIsDealerProfileEditEmailSended(false));
    onCloseProfileModal();
  }
  const onClickConfirmBtn = () => {
    logAnalyticsEvent(analyticsEvents.sendProfileToDealer);
    dispatch(callToSendProfileEditEmail({ license_key: data?.license_key }))
  }
  function clearLicenseHistory() {
    dispatch(setLicenseHistory([]));
    dispatch(setIsLicenseHistoryInProgress(false));
    dispatch(setIsLicenseHistoryCompleted(false));
  }

  const handleLicenseHistory = () => {
    clearLicenseHistory();
    const { first1, second2, last5 } = formatLicenseKey(
      data.licenseId as string
    );
    dispatch(
      callToGetLicenseHistory({
        first3: `${first1}${second2}`,
        last5: `${last5}`
      })
    );
  };

  const RemoveLicense = () => {
    dispatch(callToRemoveLicense({ license_key: data?.license_key, type: 'FFL' }))
  }
  const callLicenseRemoved = () => {
    dispatch(setIsLicenseRemoved(data.has_verified_certificate as boolean))
  }


  const onTransferOpenHandler = () => {
    const dealerErrorMsg = optOutExploreMessage[dealerOptOutValue as KeyType]
    let errorMsg = '';
    if (isBlacklisted && isDealerOptOut) {
      errorMsg = `${BLACKLIST_ERROR}, ${dealerErrorMsg}`
    } else if (isBlacklisted) {
      errorMsg = BLACKLIST_ERROR
    } else if (isDealerOptOut) {
      errorMsg = dealerErrorMsg
    }
    if (errorMsg && isBlacklisted || isDealerOptOut) {
      ErrorToasterNotification(errorMsg);
    } else {
      onTransferOpen();
    }
  };
  const handleShootingRangeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const isShootingRange = event.target.checked;
    const payload = {
      license_key: data?.license_key,
      isRange: isShootingRange,
    };
    dispatch(callToShootingChange(payload));
    setIsShootingRangeChecked(isShootingRange);
  }
  const dealerData:any = {
    ...data,
    transferFees:{
      extraFirearmFee : data?.transferFees?.nfaFee
    }
  }
  return (
    <>
      {isBusinessDetailsEditDropdownActive && (
        <BusinessDetailsEdit
          isOpen={isBusinessDetailsEditDropdownActive}
          onClose={onCloseBusinessDetailsEditDropdown}
          contactNames={contactNames || []}
          phoneNumbers={phones || []}
          emails={emails || []}
          licenseKey={data.license_key}
          websites={websites}
          primaryEmail={getPrimary(emails) || ""}
          primaryPhone={getPrimary(phones) || ""}
          contactDetailsList={contactDetailsList || []}
          customeAddressList={customeAddressList || []}
          defaultShippingAddressCurrent={defaultShippingAddress || null}
          licenseDetails={data}
        />
      )}
      {isTrasnferEditModalActive && (
        <EditTransferFee
          isOpen={isTrasnferEditModalActive}
          onClose={onCloseTrasnferEditModalActive}
          transferFees={transferFees}
          licenseKey={data.license_key}
          isBlacklisted={isBlacklisted}
          optOutOptions={optinOptoutValue || ""}
        />
      )}
      <FFLDealerDetails
        data={dealerData}
        isSuperAdmin={isSuperAdmin}
        getPrimary={getPrimary}
        getBusinessDetailsEdited={getBusinessDetailsEdited}
        getIsLicenseRemoved={getIsLicenseRemoved}
        getIsBlacklisted={getIsBlacklisted}
        onClickEditBusinessDetails={onClickEditBusinessDetails}
        onClickEditTransferDetails={onClickEditTransferDetails}
        transferDetailsProps={{ transferFees: {extra_firearm_fee: transferFees.suppressor_fee, ...transferFees}, optinOptoutValue: optinOptoutValue }}
        licenseInfoProps={{
          handleLicenseHistory: handleLicenseHistory,
          RemoveLicense: RemoveLicense,
          callLicenseRemoved: callLicenseRemoved,
          getIsLicenseHistoryCompleted: getIsLicenseHistoryCompleted,
          getIsLicenseHistoryInProgress: getIsLicenseHistoryInProgress,
          getLicenseHistoryList: getLicenseHistoryList
        }}
        businessDetailsProps={{
          getContactDetailsEdit: getContactDetailsEdit,
          getCustomAddressEdit: getCustomAddressEdit,
          getTotalTransfersCount: getTotalTransfersCount,
        }}
        licenseDetailsHeaderProps={{
          getDealerOptOutValue: getDealerOptOutValue,
          getEzCheckHistory: getEzCheckHistory,
          getIsDealerOptOut: getIsDealerOptOut,
          getIsDealerProfileEditEmailSended: getIsDealerProfileEditEmailSended,
          getIsEzCheckHistoryInCompleted: getIsEzCheckHistoryInCompleted,
          getIsEzCheckHistoryInprogress: getIsEzCheckHistoryInprogress,
          getIsSendingDealerProfileEditEmail: getIsSendingDealerProfileEditEmail,
          handleEzCheck: handleEzCheck,
          downloadPdfFile: downloadPdfFile,
          onOpenEZDropdownHanlder: onOpenEZDropdownHanlder,
          LicenseRemoved: LicenseRemoved,
          DealerProfileEditEmailSended: DealerProfileEditEmailSended,
          onTransferOpen: onTransferOpenHandler,
          processingDownload: processingDownload,
          isEZDropDOwnActive: isEZDropDOwnActive,
          onOpenProfileModal: onOpenProfileModal,
          onCloseEZDropdown: onCloseEZDropdown
        }}
        isShootingRangeChecked={isShootingRangeChecked}
        onShootingRangeChange={handleShootingRangeChange}
      />
      <TransferModal
        isOpen={isTransferOpen}
        onClose={onTransferClose}
        licensee={data}
      />
      <ConfirmationModal
          isOpen={isProfileModalOpen}
          onClose={onCloseProfileModal}
          modalHeader ={'Email Confirmation!'}
          isCancelBtnDisable={isSendingDealerProfileEditEmail}
          isConfirmBtnDisable={isSendingDealerProfileEditEmail}
          isConfirmBtnLoading={isSendingDealerProfileEditEmail}
          onClickConfirmBtn={onClickConfirmBtn}
          modalContent={
            <>Are you sure you want to send a profile edit link to this dealer "{getPrimary(emails) || ''}"?</>
          }
        />
    </>
  );
}

export default LicenseDetails;
